import React from "react";
import { ProfileCard } from "../../atoms";

import "./all-rankings.m.css";

export const GridView = ({
  snapshotByRank,
  visibleItemsForGrid,
  rankingEntitySlug,
  cdnImage,
  isSsr,
  isRankingDetail = false,
  eventAction = "",
}) => {
  return (
    <>
      {snapshotByRank.slice(0, visibleItemsForGrid).map((entityData = {}, index) => {
        const entityType = entityData["entity-type"];
        if (entityType === "year") return null;
        return (
          <ProfileCard
            showRanking={rankingEntitySlug === "most-powerful-women"}
            entityData={entityData}
            key={`${entityData?.id}-${index}`}
            customStyleName="entity-detail"
            cdnImage={cdnImage}
            isSsr={isSsr}
            position={index + 1}
            isRankingDetail={isRankingDetail}
            eventAction={eventAction}
          />
        );
      })}
    </>
  );
};
